import formatFileSize from './utils'

const messages = {
  _default: () => `vērtība nav derīga.`,
  after: (field, [target, inclusion]) =>
    `jābūt pēc ${inclusion ? 'vai vienāds ar' : ''}${target}.`,
  alpha_dash: () =>
    `laukā drīkst būt burtu-ciparu rakstzīmes, kā arī domuzīmes un apakšsvītras.`,
  alpha_num: () =>
    `laukā drīkst būt tikai burtu-ciparu rakstzīmes.`,
  alpha_spaces: () =>
    `laukā drīkst būt tikai alfabēta rakstzīmes, kā arī atstarpes.`,
  alpha: () => `laukā drīkst būt tikai alfabēta rakstzīmes.`,
  before: (field, [target, inclusion]) =>
    `jābūt pirms ${inclusion ? 'vai vienāds ar' : ''}${target}.`,
  between: (field, [min, max]) =>
    `laukam jābūt no ${min} līdz ${max}.`,
  confirmed: () => `apstiprinājums nesakrīt.`,
  credit_card: () => `lauks nav derīgs.`,
  date_between: (field, [min, max]) =>
    `jābūt starp ${min} un ${max}.`,
  date_format: (field, [format]) =>
    `jābūt formātā ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `laukam jābūt skaitliskam, un tajā var būt ${!decimals || decimals === '*' ? '' : decimals
    } cipari aiz komata.`,
  digits: (field, [length]) =>
    `laukam jābūt skaitliskam un jāsatur precīzi ${length} ciparus.`,
  dimensions: (field, [width, height]) =>
    `laukam jābūt ${width} pikseļi x ${height} pikseļi.`,
  email: () => `laukam jābūt derīgam e-pastam.`,
  ext: () => `laukam jābūt derīgam failam.`,
  image: () => `laukam jābūt attēlam.`,
  in: () => `laukam ir jābūt derīgai vērtībai.`,
  integer: () => `laukam jābūt veselam skaitlim.`,
  ip: () => `laukam jābūt derīgai ip adresei.`,
  length: (field, [length, max]) => {
    if (max) {
      return `garumam jābūt starp ${length} and ${max}.`
    }

    return `garumam jābūt ${length}.`
  },
  max: (field, [length]) =>
    `lauks nedrīkst būt lielāks par ${length} rakstzīmēm.`,
  max_value: (field, [max]) => `laukam jābūt ${max} vai mazākam.`,
  mimes: () => `laukam ir jābūt derīgam faila tipam.`,
  min: (field, [length]) =>
    `laukā jābūt vismaz ${length} rakstzīmes.`,
  min_value: (field, [min]) => `laukam jābūt vismaz ${min} vai lielākai`,
  not_in: () => `laukam jābūt derīgai vērtībai.`,
  numeric: () => `laukā drīkst būt tikai ciparu rakstzīmes.`,
  regex: () => `lauka formāts nav derīgs.`,
  required: () => `lauks ir obligāts.`,
  size: (field, [size]) =>
  `izmēram jābūt mazākam par ${formatFileSize(size)}.`,
  url: () => `laukā nav derīgs URL.`,
  fullName: () => `nav derīgs (nosaukums, vārds un max 20 rakstzīmes)`,
  emailInput: () => 'Laukā jābūt derīgai e-pasta adresei.',
  fullNamePerCountry: () => 'nav derīgs (nosaukums, vārds un max 18 rakstzīmes)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'lv',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/lv.js